import { render, staticRenderFns } from "./link-translation-extended-preference-modal.vue?vue&type=template&id=67a0eff1"
import script from "./link-translation-extended-preference-modal.vue?vue&type=script&lang=js"
export * from "./link-translation-extended-preference-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports